import {
  createComponentApi
} from "./chunk-EM2GWIPP.js";
import {
  createUserApi
} from "./chunk-W76QUDRH.js";
import {
  createStoryApi
} from "./chunk-7S4VEZBF.js";
import {
  createTagApi
} from "./chunk-RCQQVZ2O.js";
import "./chunk-X7Z2OBKV.js";
import {
  Newsroom,
  Provider
} from "./chunk-IUHVRWTE.js";
import {
  createEditorApi
} from "./chunk-IHHKXTC4.js";
import {
  createImageApi
} from "./chunk-6GW4OEXP.js";
import {
  createPageApi
} from "./chunk-CNIKPTW3.js";

// src/index.ts
var createApi = (client, provider) => {
  return {
    component: createComponentApi(client, provider),
    editor: createEditorApi(client, provider),
    user: createUserApi(client),
    image: createImageApi(client, provider),
    story: createStoryApi(client, provider),
    tag: createTagApi(client, provider),
    page: createPageApi(client, provider)
  };
};
export {
  Newsroom,
  Provider,
  createApi
};
